import { Button, DataTable } from "@/components";
import { X } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { getBannerData } from "../../utils/Data";
import ColumnHelper from "@/utils/ColumnHelper";
import { useDispatch, useSelector } from "react-redux";
import { SpaceWrapper } from "../../components";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { PiPresentationFill } from "react-icons/pi";
import { fetchBanners, removeBanner, selectAllBanners } from "../../app/Slices";
import BannerForm from "./BannerForm";
import { useAlert, useConfirmationDialog } from "@/";
const Banner = () => {
  const { alert, AlertDialog: Dialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const fetchData = async () => {
    const response = await dispatch(fetchBanners());
    console.log("response::::::", response);
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);
  const banners = useSelector(selectAllBanners) || [];
  const isBannersLoading = useSelector((state) => state.banners.loading);
  const handleDeleteBanner = async (id) => {
    if (!id) {
      alert("Banner ID is required.");
      return;
    }

    await confirm("Are you sure you want to delete this banner?");

    try {
      await dispatch(removeBanner({ id })).unwrap();
      await alert("Banner removed successfully!");
    } catch (error) {
      await alert(error || "Failed to remove banner.");
    }
  };
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "S.No.",
        cell: (info) => info.row.index + 1,
        meta: {
          tooltip: (row) => (row.index + 1).toString() || "N/A",
        },
        width: "50px",
      }),
      ColumnHelper({
        header: "Image",
        accessorKey: "imageUrl", // Matches API response
        cell: (info) => {
          return (
            <div className="flex gap-1 justify-center items-center">
              <img
                src={info.row.original.imageUrl}
                alt="Contact Image"
                className="w-28 h-16 object-fit rounded-xl bg-transparent"
                crossOrigin="anonymous"
              />
            </div>
          );
        },
        meta: {
          tooltip: (row) => row.contactImage || "N/A",
        },
      }),
      ColumnHelper({
        header: "Title",
        accessorKey: "title", // Matches API response
        meta: {
          tooltip: (row) => row.title || "N/A",
        },
      }),
      ColumnHelper({
        header: "Descreption",
        accessorKey: "subtitle", // Matches API response
        meta: {
          tooltip: (row) => row.subtitle || "N/A",
        },
      }),
      ColumnHelper({
        header: "Actions",
        accessorKey: "id",
        cell: (info) => {
          const [rowAlertOpen, setAlertSheetOpen] = useState(false);
          return (
            <div className="flex gap-1 justify-center items-center">
              <AlertDialog open={rowAlertOpen} onOpenChange={setAlertSheetOpen}>
                <AlertDialogTrigger asChild>
                  <Button size="xs">Edit</Button>
                </AlertDialogTrigger>
                <AlertDialogContent className="!bg-background !rounded-xl !w-full">
                  <button
                    onClick={() => setAlertSheetOpen(false)}
                    className="flex absolute right-4 top-4 justify-center !h-6 !w-6 !grow-0 !shrink-0 items-center rounded-md bg-background_2/60 hover:bg-primary/30 transition-all"
                  >
                    <X className="!h-3 text-secondary/60" />
                  </button>
                  <AlertDialogHeader>
                    <AlertDialogTitle className="font-nunito !text-secondary/90 !font-bold !text-headline4 md:!!text-headline3 !ml-2 flex justify-between items-center">
                      Edit Banner
                    </AlertDialogTitle>
                    <AlertDialogDescription className="!w-full flex flex-col !gap-4 !mt-6"></AlertDialogDescription>
                  </AlertDialogHeader>
                  <BannerForm
                    setAlertOpen={setAlertSheetOpen}
                    data={info.row.original}
                    isEdit={true}
                  />
                </AlertDialogContent>
              </AlertDialog>
              <Button
                size="xs"
                variant="destructive"
                onClick={() => handleDeleteBanner(info.row.original.id)}
              >
                Delete
              </Button>
            </div>
          );
        },
        meta: {
          tooltip: () => "Edit or delete banner",
        },
      }),
    ],
    []
  );

  const data = useMemo(() => getBannerData(20), []);
  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row lg:justify-between items-end gap-6 lg:gap-2">
          <div className="flex flex-col gap-1 ">
            <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
              Banner
            </h1>
          </div>
          <div className="flex gap-1  ">
            <AlertDialog open={alertOpen} onOpenChange={setAlertOpen}>
              <AlertDialogTrigger asChild>
                <Button
                  icon={PiPresentationFill}
                  className="h-12"
                  size="md"
                  onClick={() => console.log("Add Banner")}
                >
                  Add Banner
                </Button>
              </AlertDialogTrigger>
              <AlertDialogContent className="!bg-background !rounded-xl !w-full !h-fit ">
                <button
                  onClick={() => setAlertOpen(false)}
                  className="flex absolute right-4 top-4 justify-center !h-6 !w-6 !grow-0 !shrink-0 items-center rounded-md bg-background_2/60 hover:bg-primary/30 transition-all"
                >
                  <X className="!h-3 text-secondary/60" />
                </button>
                <AlertDialogHeader>
                  <AlertDialogTitle className="font-nunito !text-secondary/90 !font-bold !text-headline4 md:!!text-headline3 !ml-2 flex justify-between items-center">
                    Add Banner
                  </AlertDialogTitle>

                  <AlertDialogDescription className="!w-full flex flex-col"></AlertDialogDescription>
                </AlertDialogHeader>
                <BannerForm setAlertOpen={setAlertOpen} />
              </AlertDialogContent>
            </AlertDialog>
          </div>
        </div>
        <DataTable
          columns={columns}
          tittle="Live Banners"
          isLoading={isBannersLoading}
          data={banners}
          showCheckbox={false}
        />
      </div>
      <Dialog />
      <ConfirmationModal />
    </SpaceWrapper>
  );
};

export default Banner;
